<template>
    <div id="MobileVerify">
      <!-- tab 1 content -->
      <form data-vv-scope="MobileVerify" autocomplete="off">
        <div class="vx-row">
          <div class="vx-col md:w-2/5 w-full mt-5 mx-auto">
            <vs-input :label="$t('Mobile')" size="large" v-model="mobile" :disabled="sendSms" :readonly="mobileHas" name="mobile" maxlength="11" class="w-full"
                      :success="mobileHas ? true : false" :val-icon-success="mobileHas ? 'icon-check' : null" val-icon-pack="feather"
                       :class="$vs.rtl ? 'rtl' : 'ltr'" v-validate="'required|numeric|min:11|max:11'"/>
            <span class="text-danger text-sm" v-show="errors.has('MobileVerify.mobile') && this.MobileSubmit">{{ errors.first('MobileVerify.mobile') }}</span>
          </div>
        </div>
        <transition name="slide">
          <div class="vx-row" v-if="sendSms">
            <div class="vx-col md:w-2/5 w-full mt-5 mx-auto">
              <vs-input :label="$t('SMS code')" size="large" v-model="code" name="code" maxlength="6" class="w-full"
                        :class="$vs.rtl ? 'rtl' : 'ltr'" v-validate="'required|numeric|min:6|max:6'" ref="codeInput"/>
              <span class="text-danger text-sm" v-show="errors.has('MobileVerify.code') && this.MobileSubmit">{{ errors.first('MobileVerify.code') }}</span>
            </div>
          </div>
        </transition>
        <div class="vx-row" v-if="!mobileHas">
          <div class="vx-col w-full"></div>
          <div class="vx-col md:w-2/5 w-full mt-5 mx-auto">
            <vs-button class="ml-auto mt-2 w-full" id="button-submit-mobile-verify" :disabled="btnDisable || mobileHas" @click.prevent="MobileFormSubmit">
              {{!sendSms ? $t('Send verification code') : $t('Confirm code')}}
            </vs-button>
          </div>
        </div>
      </form>
    </div>
</template>

<script>

import axios from "../../../http/axios";

export default {
  props: {
    mobileHas: {
      required: true,
    }
  },
  name: 'MobileVerify',
  data () {
    return {
      mobile: '',
      code: '',
      MobileSubmit: false,
      sendSms: false,
      btnDisable: false,
    }
  },
  watch:{
    mobile (value) {
      value = this.parseNumberArabic(value)
      this.mobile = value.replace(/[^\d]/g, '')
    },
  },
  methods: {
    MobileFormSubmit () {
      this.$validator.validateAll('MobileVerify').then(result => {
        if (result) {
          // if form have no errors
          this.$vs.loading({
            background: this.backgroundLoading,
            color: this.colorLoading,
            container: '#button-submit-mobile-verify',
            scale: 0.65
          })
          this.btnDisable = true;
          /////
          const payload = {
            mobile: this.mobile,
            code: this.code
          }
          const self = this
          axios.post('/authentication/mobile', payload)
            .then(function (response) {
              if (response.data.status == true) {
                self.$swal({
                  icon: 'success',
                  title: self.$t('Success'),
                  text: response.data.msg
                }).then(() => {
                  if(response.data.send == true){
                    self.sendSms = true;
                    setTimeout(()=>{
                      self.$refs.codeInput.$el.querySelector('input').focus()
                    },500)
                  }
                  else if(response.data.done == true){
                    self.sendSms = false
                    self.$emit('getData')
                    //self.$emit('nextTab')
                  }
                })

              } else {
                self.$vs.notify({
                  title: self.$t('Error'),
                  text: response.data.msg,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
              }
              self.btnDisable = false
              self.$vs.loading.close('#button-submit-mobile-verify > .con-vs-loading')
            })
            .catch(function (error) {
              console.log(error)
              self.btnDisable = false
              self.$vs.loading.close('#button-submit-mobile-verify > .con-vs-loading')
            })

        } else {
          this.MobileSubmit = true
        }
      })
    },
    parseNumberArabic (value) {
      return (value.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (d) {
        return d.charCodeAt(0) - 1632
      }).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, function (d) { return d.charCodeAt(0) - 1776 })
      )
    },

  },
  created() {
    if(this.mobileHas)
      this.mobile = this.mobileHas;
  }
}
</script>

<style scoped>

</style>
